<p-toast></p-toast>

<p-toast position="top-left" key="tl"></p-toast>

<p-toast position="top-center" key="tc"></p-toast>

<p-toast styleClass="custom-toast" key="custom" position="bottom-center" [showTransformOptions]="'translateX(-100%)'">
</p-toast>

<p-toast position="center" key="c" (onClose)="onReject()" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div style="text-align: center">
            <i class="pi pi-exclamation-triangle" style="font-size: 3em"></i>
            <h3>{{message.summary}}</h3>
            <p>{{message.detail}}</p>
        </div>
        <div class="p-grid ui-fluid">
            <div class="p-col-6">
                <button type="button" pButton (click)="onConfirm()" label="Yes" class="ui-button-success"></button>
            </div>
            <div class="p-col-6">
                <button type="button" pButton (click)="onReject()" label="No" class="ui-button-secondary"></button>
            </div>
        </div>
    </ng-template>
</p-toast>